import React, {useEffect, useState} from 'react';
import DetailDialog from '../../../../../components/DetailDialog';
import Certificates from './Certificates';

const CertificatesDialog = ({job, open, onClose}) => {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    if (job) {
      const list = [
        ...(job.contact?.email ? [{contact: job.contact}] : [])
      ];
      if (job.company?.contacts) {
        job.company.contacts.forEach(contact => {
          if (contact.email) {
            const index = list.findIndex(({contact: c}) => c.id === contact.id);
            if (index < 0) {
              list.push({contact});
            }
          }
        });
      }
      setContacts([...list]);
    }
  }, [job]);

  return job ? (
    <>
      <DetailDialog
        title="Certificates"
        maxWidth="lg"
        open={open}
        onClose={onClose}
        actions={[
          {label: 'Close', colour: 'primary', onClick: () => onClose()}
        ]}
      >
        <Certificates job={job} contacts={contacts}/>
      </DetailDialog>
    </>
  ) : null;
}

export default CertificatesDialog;
